import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, useMediaQuery, Typography } from "@mui/material";

//json2mq
import json2mq from "json2mq";

const useStyles = (theme, background) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100% 109%" },
    width: "100vw",
    backgroundImage: {
      xs: `url(${background})`,
    },
    minHeight: { xs: "611px" },
    alignItems: "center",
    justifyContent: "center",
  },
  msg: {
    color: theme.palette.white.main,
    fontSize: { xs: "30px", md: "60px", lg: "70px", xl: "75px" },
    fontFamily: theme.typography.montserrat.bold,
    mt: { xs: "80px" },
    textAlign: { xs: "center" },
    width: { xs: "300px", md: "660px", lg: "740px", xl: "840px" },
  },
  description: {
    color: theme.palette.white.main,
    fontSize: { xs: "23px", md: "32px" },
    lineHeight: { xs: "43px", md: "36px" },
    fontFamily: theme.typography.montserrat.bold,
    mt: { xs: "40px" },
    textAlign: { xs: "center" },
    width: { xs: "350px", md: "650px" },
    mb: { md: "150px" },
  },
});

const StatusCard = ({ img, background, msg, description }) => {
  const theme = useTheme();
  const classes = useStyles(theme, background);

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 900,
    })
  );

  const sm = useMediaQuery(
    json2mq({
      maxWidth: 1000,
      minWidth: 900,
    })
  );

  const md = useMediaQuery(
    json2mq({
      maxWidth: 1199,
      minWidth: 1000,
    })
  );

  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1200,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
      maxWidth: 1700,
    })
  );

  const xxl = useMediaQuery(
    json2mq({
      minWidth: 1701,
    })
  );

  const stylesHelper = () => {
    if (xl || xxl) {
      return {
        mainImage: { width: "350px", height: "350px", marginTop: "30px" },
      };
    } else if (sm)
      return {
        mainImage: { width: "325px", height: "275px", marginTop: "30px" },
      };
    else if (md) {
      return {
        mainImage: { width: "250px", height: "250px", marginTop: "30px" },
      };
    } else if (lg) {
      return {
        mainImage: { width: "325px", height: "350px", marginTop: "30px" },
      };
    } else if (xs) {
      return {
        mainImage: { width: "229px", height: "200px" },
      };
    }
  };
  return (
    <Box sx={classes.container}>

      <Typography sx={classes.msg}>{msg}</Typography>
      <img
        alt="logo"
        src={img}
        style={stylesHelper() && stylesHelper().mainImage}
      />
      <Typography sx={classes.description}>{description}</Typography>
    </Box>
  );
};

export default StatusCard;
